<template>
    <section class="cookies">
        <transition name="cookies-fade" appear>
            <div class="bar" v-if="showCookiesBar">
                <div class="tw-container bar-content">
                    <div class="text">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.5 26.5"><g transform="translate(0.25 0.25)"><path d="M367.016,246.508a.508.508,0,1,1-.508-.508A.508.508,0,0,1,367.016,246.508Zm0,0" transform="translate(-347.414 -233.508)" fill="#484848" stroke="#484848" stroke-width="0.5"/><path d="M267.016,186.508a.508.508,0,1,1-.508-.508A.508.508,0,0,1,267.016,186.508Zm0,0" transform="translate(-252.492 -176.555)" fill="#484848" stroke="#484848" stroke-width="0.5"/><path d="M247.016,396.508a.508.508,0,1,1-.508-.508A.508.508,0,0,1,247.016,396.508Zm0,0" transform="translate(-233.508 -375.891)"  stroke-width="0.5"/><path d="M97.016,216.508a.508.508,0,1,1-.508-.508A.508.508,0,0,1,97.016,216.508Zm0,0" transform="translate(-91.125 -205.031)"  stroke-width="0.5"/><path d="M108.031,320.062A2.031,2.031,0,1,0,106,318.031,2.034,2.034,0,0,0,108.031,320.062Zm0-3.047a1.016,1.016,0,1,1-1.016,1.016A1.017,1.017,0,0,1,108.031,317.016Zm0,0" transform="translate(-100.617 -299.953)"  stroke-width="0.5"/><path d="M160.062,88.031a2.031,2.031,0,1,0-2.031,2.031A2.034,2.034,0,0,0,160.062,88.031Zm-3.047,0a1.016,1.016,0,1,1,1.016,1.016A1.017,1.017,0,0,1,157.016,88.031Zm0,0" transform="translate(-148.078 -81.633)"  stroke-width="0.5"/><path d="M306,308.031A2.031,2.031,0,1,0,308.031,306,2.034,2.034,0,0,0,306,308.031Zm3.047,0a1.016,1.016,0,1,1-1.016-1.016A1.017,1.017,0,0,1,309.047,308.031Zm0,0" transform="translate(-290.461 -290.461)"  stroke-width="0.5"/><path d="M207.523,249.047A1.523,1.523,0,1,0,206,247.523,1.525,1.525,0,0,0,207.523,249.047Zm0-2.031a.508.508,0,1,1-.508.508A.508.508,0,0,1,207.523,247.016Zm0,0" transform="translate(-195.539 -233.508)"  stroke-width="0.5"/><path d="M247.016,492.508a.508.508,0,1,1-.508-.508A.508.508,0,0,1,247.016,492.508Zm0,0" transform="translate(-233.508 -467.016)"  stroke-width="0.5"/><path d="M25.106,10.686a3.186,3.186,0,0,1-1.29.283A2.755,2.755,0,0,1,21.4,9.551a.508.508,0,0,0-.6-.261,3.248,3.248,0,0,1-.943.156,3.3,3.3,0,0,1-3.3-3.3A3.249,3.249,0,0,1,16.71,5.2a.508.508,0,0,0-.261-.6,2.755,2.755,0,0,1-1.418-2.418,3.186,3.186,0,0,1,.283-1.29.508.508,0,0,0-.376-.731A12.557,12.557,0,0,0,13,0,13.22,13.22,0,0,0,0,13,13.261,13.261,0,0,0,10.628,25.77a.508.508,0,1,0,.195-1A12.23,12.23,0,0,1,1.016,13,12.145,12.145,0,0,1,13,1.016a10.426,10.426,0,0,1,1.167.069,4.352,4.352,0,0,0-.151,1.1A3.864,3.864,0,0,0,15.636,5.3a3.874,3.874,0,0,0-.1.846,4.321,4.321,0,0,0,4.316,4.316,3.874,3.874,0,0,0,.846-.1,3.864,3.864,0,0,0,3.115,1.62,4.352,4.352,0,0,0,1.1-.151A10.426,10.426,0,0,1,24.984,13a12.23,12.23,0,0,1-9.807,11.773.508.508,0,0,0,.195,1A13.261,13.261,0,0,0,26,13a12.557,12.557,0,0,0-.163-1.938A.508.508,0,0,0,25.106,10.686Zm0,0" transform="translate(0 0)"  stroke-width="0.5"/></g></svg>
                        <p>
                            <span v-html="$t('cookie.notice')"></span>
                            &nbsp;
                            <a href="#" @click.prevent="cookiesModal = true">{{ $t('cookie.learnMore') }}</a>
                        </p>
                    </div>
                    <button type="button" class="btn-cookie tw-pointer-events-auto" @click.prevent="acceptCookies">
                        {{ $t('cookie.allowCookies')}}
                    </button>
                </div>
            </div>
        </transition>

        <div class="modal tw-fixed tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-z-50 tw-duration-300"
             :class="{'tw-opacity-0 tw-pointer-events-none' : !cookiesModal}"
            >
            <div class="modal-overlay tw-absolute tw-w-full tw-h-full tw-bg-black tw-opacity-50"></div>
            <div class="modal-dialog modal-container tw-bg-white md:tw-max-w-screen-md tw-w-11/12 tw-mx-auto tw-rounded-lg tw-shadow-lg tw-z-50 tw-overflow-y-auto">
                <div class="modal-content tw-pt-6 tw-pb-12 tw-text-left tw-px-6">
                    <div class="tw-flex tw-justify-between tw-items-center tw-pb-3">
                        <h4 class="tw-text-2xl tw-font-bold">{{ $t('cookie.modal.title') }}</h4>
                        <div class="modal-close tw-cursor-pointer tw-z-50" @click="cookiesModal = false">
                            <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567"><g transform="translate(16.821 16.749) rotate(180)"><path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5"/></g></svg>
                        </div>
                    </div>
                    <div class="modal-body tw-mt-5">
                        <h5 class="tw-mb-4">{{ $t('cookie.modal.subTitle') }}</h5>
                        <p class="tw-mb-6">
                            {{ $t('cookie.modal.text') }}
                        </p>
                        <div class="tw-w-full tw-text-center tw-mb-4">
                            <button type="button" class="tw-mx-auto btn-cookie focus:tw-outline-none tw-w-auto tw-block" @click.prevent="acceptCookies">
                                {{ $t('cookie.modal.allowAll') }}
                            </button>
                        </div>
                        <hr>
                        <div class="cookie-toggle-line">
                            <p>AdRoll</p>
                            <label class="switch">
                                <input type="checkbox" v-model="adroll">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <hr>
                        <div class="cookie-toggle-line">
                            <p>Facebook</p>
                            <label class="switch">
                                <input type="checkbox" v-model="facebook">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <hr>
                        <div class="cookie-toggle-line">
                            <p>LinkedIn</p>
                            <label class="switch">
                                <input type="checkbox" v-model="linkedin">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <hr>
                        <div class="cookie-toggle-line">
                            <p>Google AdWords</p>
                            <label class="switch">
                                <input type="checkbox" v-model="google">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <hr>
                        <div class="cookie-toggle-line">
                            <p>Hotjar</p>
                            <label class="switch">
                                <input type="checkbox" v-model="hotjar">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <hr>
                        <div class="tw-w-full tw-text-center tw-mt-4">
                            <button type="button" class="btn-cookie tw-w-auto tw-block tw-mx-auto tw-focus:outline-none" @click.prevent="saveCookies">
                                {{ $t('cookie.modal.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'cookies-consent',
    data() {
        return {
            showCookiesBar: true,
            cookiesModal: false,

            facebook: true,
            adroll: true,
            linkedin: true,
            google: true,
            hotjar: true,
        };
    },
    methods: {
        acceptCookies() {
            const script = document.createElement('script');
            const img = document.createElement('img');

            // Facebook
            const fb = img;
            fb.setAttribute('src', 'https://www.facebook.com/tr?id=247649629153057&ev=PageView&noscript=1');
            fb.setAttribute('height', '1');
            fb.setAttribute('width', '1');
            fb.style.display = 'none';
            document.head.appendChild(fb);

            // Adroll
            const adroll = script;
            adroll.type = 'application/javascript';
            adroll.innerHTML = 'adroll_adv_id="GY3PHHSNB5FJDH2Z6DXJ6B",adroll_pix_id="RDZBXDRHUVGEJOEGI3VCD5",function(){var t=function(){if(!document.readyState||/loaded|complete/.test(document.readyState)){if(!window.__adroll_loaded)return __adroll_loaded=!0,void setTimeout(t,50);var e=document.createElement("script"),d="https:"==document.location.protocol?"https://s.adroll.com":"http://a.adroll.com";e.setAttribute("async","true"),e.type="text/javascript",e.src=d+"/j/roundtrip.js",((document.getElementsByTagName("head")||[null])[0]||document.getElementsByTagName("script")[0].parentNode).appendChild(e)}else setTimeout(t,10)};window.addEventListener?window.addEventListener("load",t,!1):window.attachEvent("onload",t)}();';
            document.body.appendChild(adroll);

            // Linkedin
            const linkedin = img;
            linkedin.src = 'https://dc.ads.linkedin.com/collect/?pid=412002&fmt=gif';
            linkedin.height = '1';
            linkedin.width = '1';
            linkedin.style.display = 'none';
            document.body.appendChild(linkedin);
            // google
            const gtag = script;
            const gtagContent = script;
            gtag.type = 'application/javascript';
            gtag.async = true;
            gtag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-121410254-1';

            gtagContent.innerHTML = 'function gtag(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],gtag("js",new Date),gtag("config","UA-121410254-1");';
            document.head.appendChild(gtag);
            document.head.appendChild(gtagContent);

            document.cookie = 'cookie-accept=true; expires=Thu, 18 Dec 2023 12:00:00 UTC';
            this.cookiesModal = false;
            this.showCookiesBar = false;
        },
        saveCookies() {
            const script = document.createElement('script');
            const img = document.createElement('img');

            // Facebook
            if (this.facebook) {
                const fb = img;
                fb.setAttribute('src', 'https://www.facebook.com/tr?id=247649629153057&ev=PageView&noscript=1');
                fb.setAttribute('height', '1');
                fb.setAttribute('width', '1');
                fb.style.display = 'none';
                document.head.appendChild(fb);
            }
            // Adroll
            if (this.adroll) {
                const adroll = script;
                adroll.type = 'application/javascript';
                adroll.innerHTML = 'adroll_adv_id="GY3PHHSNB5FJDH2Z6DXJ6B",adroll_pix_id="RDZBXDRHUVGEJOEGI3VCD5",function(){var t=function(){if(!document.readyState||/loaded|complete/.test(document.readyState)){if(!window.__adroll_loaded)return __adroll_loaded=!0,void setTimeout(t,50);var e=document.createElement("script"),d="https:"==document.location.protocol?"https://s.adroll.com":"http://a.adroll.com";e.setAttribute("async","true"),e.type="text/javascript",e.src=d+"/j/roundtrip.js",((document.getElementsByTagName("head")||[null])[0]||document.getElementsByTagName("script")[0].parentNode).appendChild(e)}else setTimeout(t,10)};window.addEventListener?window.addEventListener("load",t,!1):window.attachEvent("onload",t)}();';
                document.body.appendChild(adroll);
            }
            // Linkedin
            if (this.linkedIn) {
                const linkedin = img;
                linkedin.src = 'https://dc.ads.linkedin.com/collect/?pid=412002&fmt=gif';
                linkedin.height = '1';
                linkedin.width = '1';
                linkedin.style.display = 'none';
                document.body.appendChild(linkedin);
            }
            // google
            if (this.google) {
                const gtag = script;
                const gtagContent = script;
                gtag.type = 'application/javascript';
                gtag.async = true;
                gtag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-121410254-1';

                gtagContent.innerHTML = 'function gtag(){dataLayer.push(arguments)}window.dataLayer=window.dataLayer||[],gtag("js",new Date),gtag("config","UA-121410254-1");';
                document.head.appendChild(gtag);
                document.head.appendChild(gtagContent);
            }

            document.cookie = 'cookie-accept=true; expires=Thu, 18 Dec 2023 12:00:00 UTC';
            this.cookiesModal = false;
            this.showCookiesBar = false;
        },
    },
    mounted() {
        if (document.cookie.match(/^(.*;)?\s*cookie-accept\s*=\s*[^;]+(.*)?$/)) {
            this.showCookiesBar = false;
        }
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

.bar {
    position: fixed;
    right: 10px;
    bottom: 0;
    left: 0;
    z-index: 48;
    padding: 15px 0;
    width: 100%;
    border: 1px solid #edeff2;
    background-color: #fff;
    color: #484848;
    font-size: 11px;
    pointer-events: none;

    @screen md {
        font-size: 13px;
    }

    &-content {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        @screen md {
            @apply flex-row;
        }

        .text {
            display: flex;
            align-items: center;

            svg {
                width: 22px;
                height: auto;

                @screen md {
                    width: 26px;
                }
                path {
                    fill: $main_color;
                    stroke: $main_color;
                }
            }
            p {
                margin: 0;
                margin-left: 15px;
                padding: 0;
            }
            a {
                color: #484848;
                text-decoration: underline;
                font-weight: 700;
                font-size: 11px;
                pointer-events: all;
                @screen md {
                    font-size: 13px;
                }
            }
        }
    }
}

.modal {
    color: #484848;

    &-header {
        display: flex;
        align-items: center;
        background-color: #edeff2;

        h4 {
            margin: 0;
            padding: 0;
            font-weight: 700;
            font-size: 16px;
            @screen md {
                font-size: 19px;
            }
        }
    }
    &-body {
        h5 {
            font-weight: 700;
            font-size: 14px;
            @screen md {
                font-size: 16px;
            }
        }
        hr {
            margin: 0;
            border-width: 1px;
            @apply border-gray-300 w-full;
        }
        p {
            font-size: 11px;
            @screen md {
                font-size: 12px;
            }
        }
    }
}

.cookie-toggle-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    border-collapse: collapse;

    p {
        margin: 0;
        padding: 0;
        font-weight: 700;
        font-size: 14px;
    }
}
.btn-cookie {
    padding: 0 20px;
    height: 34px;
    border-radius: 50px;
    background-color: $main_color;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    transition: all .15s ease;

    &:hover {
        background-color: darken($main_color, 10%);
    }
}
.switch {
    position: relative;
    display: inline-block;
    margin-bottom: 0;
    width: 60px;
    height: 30px;

    .slider {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #ccc;
        cursor: pointer;
        transition: .4s;

        &:before {
            position: absolute;
            top: 50%;
            left: 2px;
            width: 26px;
            height: 26px;
            background-color: white;
            content: '';
            transition: .4s;
            transform: translate(0, -50%);
        }
        &.round {
            border-radius: 30px;

            &:before {
                border-radius: 50%;
            }
        }
    }
    input {
        width: 0;
        height: 0;
        opacity: 0;

        &:checked+ .slider {
            background-color: $main_color;
        }
        &:checked+ .slider:before {
            transform: translate(30px, -50%);
        }
    }
}

// Animations
.cookies-fade-enter-active, .cookies-fade-leave-active {
    transition-duration: .5s;
    transition-property: transform;
}
.cookies-fade-enter-active {
    transition-delay: 1.5s;
}
.cookies-fade-enter, .cookies-fade-leave-to {
    transform: translate3d(0, 100%, 0);
}

</style>
